/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik, Field } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import { differenceInCalendarDays, isAfter } from 'date-fns';
import Layout from 'components/Layout';
import Colors from 'constants/Colors';
import { ButtonContent } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import StepNavigation from 'components/StepNavigation'
import {
  Table,
  DialogCalculation,
  NotesModal,
  Button,
  ButtonContainer,
  LostCancelButton,
  FormSection,
  HasPermission,
  MobileTable,
  Clauses
} from '@fitinsur/components'
import TableCalculationList from 'components/TableCalculationList'
import {
  AddButton,
  Content,
  TitleBar,
  TitleInfo,
  TitleAlter,
  Option,
  BrokerContainer,
  CoverageContainer,
  Plan,
  TextQuestion,
  ClausesContainer,
  ClauseContent
} from './styles';
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import BrokingSummary from 'components/BrokingSummary';
import MasksHelper from 'utils/src/masks';
import Icon from 'components/Icon'
import * as yup from 'yup';
import { isNumber } from '@fitinsur/utils';
import { CheckBox } from "@fitinsur/components";
import { useGetDocuments, useGetDocuments as useGetDocumentsExpired } from 'services/DocumentsService';
import { useRecalculateSync, useComissionRate } from 'services/PremiumCalculationService';
import {
  LoaderContext
} from '@fitinsur/contexts'
import { useGetOperation, useResetOperationState, useUpdateOperationSync } from 'services/OperationService';
import { useVerifyRiskAcceptance } from 'services/RiskAcceptanceService';
import { useGetQuestionnaireAnswer } from 'services/QuestionnaireAnswerService';
import { useGenerateQuoteASync } from 'services/QuoteService';
import {
  useUpdateDocumentsClausesSync
} from 'services/ClausesService';

export default function Plans({ permissions, ...props }) {
  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const [notesModal, setNotesModal] = useState(false);
  const validationSchema = useRef(yup.object().shape({}));
  const loading = useContext(GlobalLoaderContext);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const authContext = useContext(GlobalAuthContext);
  const mc = new MessageCenter();
  const formikRef = useRef({});
  const recalculateParameters = useRef([])
  const [operation, setOperation] = useState({});
  const [isBound, setIsBound] = useState(true);
  const [selectedOption, setSelectedOption] = useState(null);
  const handleBack = () => history.goBack();
  const [isInAnalysis, setIsInAnalysis] = useState(null);
  const [clauseGroups, setClauseGroups] = useState([]);
  const [selectedClauses, setSelectedClauses] = useState([]);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [fullCoverageList, setFullCoverageList] = useState([]);
  const [productName, setProductName] = useState('');
  const [groupDeductible, setGroupDeductible] = useState([]);
  const [hasCoverageCalc, setHasCoverageCalc] = useState(false);
  const [idProductPlan, setIdProductPlan] = useState(0);
  const [minCommissionValue, setMinCommissionValue] = useState(0);
  const [maxComissionValue, setMaxCommissionValue] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [previousCoverageCalcList, setPreviousCoverageCalcList] = useState([]);
  const [clausesLoading, setClausesLoading] = useState(false);

  const [coverageCalcList, setCoverageCalcList] = useState([{
    coverageCalc: [{
      coverageLimit: "0",
      coveragePremium: "0",
      coverageAmount: "0",
      coverageComissionRate: "0",
      coverageComission: "0",
      coverageTax: "0",
      coverageAmountTaxLess: "0",
      deductibleDescription: "",
      coverageItems: []
    }]
  }]);

  const {
    data: useGetDocumentsData,
    loading: useGetDocumentsLoading,
    error: useGetDocumentsError,
    status: useGetDocumentsStatus,
    request: useGetDocumentsRequest
  } = useGetDocuments(props.match.params.idOperation);

  const {
    data: useGenerateQuoteData,
    loading: useGenerateQuoteLoading,
    error: useGenerateQuoteError,
    status: useGenerateQuoteStatus,
    request: useGenerateQuoteRequest
  } = useGenerateQuoteASync(props?.match?.params?.idOperation);

  const {
    data: useGetDocumentsExpiredData,
    loading: useGetDocumentsExpiredLoading,
    error: useGetDocumentsExpiredError,
    status: useGetDocumentsExpiredStatus,
    request: useGetDocumentsExpiredRequest
  } = useGetDocuments(props.match.params.idOperation);

  const {
    data: useRecalculateSyncData,
    loading: useRecalculateSyncLoading,
    error: useRecalculateSyncError,
    status: useRecalculateSyncStatus,
    request: useRecalculateSyncRequest
  } = useRecalculateSync(props.match.params.idOperation);

  const {
    data: useComissionRateData,
    loading: useComissionRateLoading,
    error: useComissionRateError,
    status: useComissionRateStatus,
    request: useComissionRateRequest
  } = useComissionRate(props.match.params.idOperation);

  const {
    loading: useUpdateOperationLoading,
    request: useUpdateOperationRequest
  } = useUpdateOperationSync(props.match.params.idOperation);

  const {
    data: useResetOperationStateData,
    loading: useResetOperationStateLoading,
    error: useResetOperationStateError,
    status: useResetOperationStateStatus,
    request: useResetOperationStateRequest,
  } = useResetOperationState(props.match.params.idOperation);

  const {
    data: useGetOperationData,
    loading: useGetOperationLoading,
    error: useGetOperationError,
    status: useGetOperationStatus,
    request: useGetOperationRequest,
  } = useGetOperation(props.match.params.idOperation);

  const {
    data: useVerifyRiskAcceptanceData,
    loading: useVerifyRiskAcceptanceLoading,
    error: useVerifyRiskAcceptanceError,
    status: useVerifyRiskAcceptanceStatus,
    request: useVerifyRiskAcceptanceRequest
  } = useVerifyRiskAcceptance(props.match.params.idOperation);

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  const {
    loading: useUpdateDocumentsClausesLoading,
    request: useUpdateDocumentsClausesRequest,
  } = useUpdateDocumentsClausesSync(props.match.params.idOperation);

  useEffect(() => {
    updateIsLoadingStatus(
      useGetDocumentsLoading ||
      useGetOperationLoading ||
      useResetOperationStateLoading ||
      useRecalculateSyncLoading ||
      useVerifyRiskAcceptanceLoading ||
      useGetQuestionnairesAnswersLoading ||
      useGetDocumentsExpiredLoading ||
      useGenerateQuoteLoading ||
      useUpdateDocumentsClausesLoading ||
      useUpdateOperationLoading ||
      useComissionRateLoading ||
      clausesLoading
    )
  }, [
    useGetDocumentsLoading,
    useRecalculateSyncLoading,
    useGetOperationLoading,
    useResetOperationStateLoading,
    useVerifyRiskAcceptanceLoading,
    useGetQuestionnairesAnswersLoading,
    useGetDocumentsExpiredLoading,
    useGenerateQuoteLoading,
    useUpdateDocumentsClausesLoading,
    useUpdateOperationLoading,
    useComissionRateLoading,
    clausesLoading
  ]);

  const getQuoteQuestionnaire = async () => {
    fitinsur.setAuthToken(authContext.token);
    let response = await fitinsur.requestProductsList().then(v => v.json())
    if (response.ret_code != 200) return;
    let product;
    response.ret_value.map(v => {
      if (v.ID_PRODUCT === Number(props.match?.params?.idProduct)) {
        product = v.PRODUCT_NAME;
      }
    });
    setProductName(product);
  }

  const handleSelectDeductible = deductible => {
    formikRef.current.setFieldValue('optionDeductible', String(deductible || 0))

    const idProductPlan = fullCoverageList?.coverageCalcList && isNumber(deductible) ?
      fullCoverageList.coverageCalcList[deductible]?.idProductPlan : null;

    if (idProductPlan) {
      useRecalculateSyncRequest(
        {
          recalculateParameters: recalculateParameters.current,
          idProductPlanSelected: idProductPlan
        },
        { draft: true }
      );
    }
  };

  const handleGetQuote = async (documentCoverageList, previousCalculation, indexCoverageCalcList) => {
    const chosenDeductible = isNumber(indexCoverageCalcList) ?
      indexCoverageCalcList : formikRef.current?.values?.optionDeductible;

    let calculations = documentCoverageList.coverageCalcList[0].coverageCalc ?
      documentCoverageList.coverageCalcList[chosenDeductible].coverageCalc :
      documentCoverageList.coverageCalcList;

    calculations = calculations.map((calculation, index) => {
      calculation.productPlanName = documentCoverageList.coverageCalcList[0].coverageCalc ?
        documentCoverageList.coverageCalcList[chosenDeductible].idProductPlanName :
        documentCoverageList.idProductPlanName;
      calculation.idProductPlan = documentCoverageList.coverageCalcList[0].coverageCalc ?
        documentCoverageList.coverageCalcList[chosenDeductible].idProductPlan :
        documentCoverageList.idProductPlan;
      calculation.option = index;
      calculation.deductibleDescription = String(calculation.deductibleDescription || 0.0);
      calculation.coverageComissionRate = (parseNumber(calculation.coverageComissionRate || 0.0) * 100).toFixed(5);

      calculation.coverageItems = calculation.coverageItems.map((coverage) => {
        coverage.coveragePremium = String(coverage.coveragePremium || 0.0);
        coverage.coveragePremiumDiscountLess = String(coverage.coveragePremiumDiscountLess || 0.0);
        coverage.coveragePremiumTaxLess = String(coverage.coveragePremiumTaxLess || 0.0);
        coverage.coveragePremiumDiscountRate = ((coverage.coveragePremiumDiscountRate || 0.0) * 100).toFixed(
          +props.match?.params?.idProduct === 34 ? 6 : 2
        );
        coverage.coverageDisabled = coverage.coverageDisabled;
        coverage.coverageLimit = String(coverage.coverageLimit ? parseNumber(coverage.coverageLimit || 0.0) : parseNumber(calculation.coverageLimit));
        coverage.deductibleDescription = String(coverage.deductibleDescription ? coverage.deductibleDescription : "");
        coverage.coverageMaxLimClaim = String(coverage.coverageMaxLimClaim ? parseNumber(coverage.coverageMaxLimClaim || 0.0) : parseNumber(calculation.coverageMaxLimClaim));
        coverage.coverageMaxLimClaimRate = (coverage.coverageMaxLimClaimRate ?
          parseNumber(coverage.coverageMaxLimClaimRate || 0.0) * 100 :
          (coverage.coverageMaxLimClaim / coverage.coverageLimit) * 100).toFixed(2);

        return coverage;
      });
      return calculation;

    })

    setIdProductPlan(calculations[0].idProductPlan);
    if (previousCalculation) {
      formikRef.current?.setFieldValue('previousCalculationList', calculations);
      setPreviousCoverageCalcList(calculations);
    } else {
      formikRef.current?.setFieldValue('calculationList', calculations);
      setCoverageCalcList(calculations);
    }
  }

  const parseNumber = (value) => {
    if (typeof (value) === 'string') {
      if (value.startsWith('%')) return Number(value.replaceAll('%', '').replaceAll(',', '.'))

      return Number(value.replaceAll('R$', '').replaceAll('.', '').replaceAll(',', '.'))
    }
    return value
  }

  useEffect(() => {
    if (useGetDocumentsStatus === 200 && useGetOperationStatus === 200) {
      //Operation
      const operationData = useGetOperationData.value;
      setOperation(operationData);
      setIsBound([5, 2, 6].includes(operationData?.idDomainStatus));

      //Quote Document
      const [quoteRequestDocument] = useGetDocumentsData.value;
      setFullCoverageList(quoteRequestDocument.documentCoverageList);
      setHasCoverageCalc(quoteRequestDocument.documentCoverageList.coverageCalcList[0].coverageCalc);
      const coverageCalcList = quoteRequestDocument.documentCoverageList?.coverageCalcList;

      //Franchises
      let indexCoverageCalcList = null;
      if (coverageCalcList) {
        indexCoverageCalcList = coverageCalcList.findIndex(
          coverage => coverage.idProductPlan === operationData?.operationMetadata?.idProductPlanSelected
        );

        if (indexCoverageCalcList !== -1) {
          formikRef.current.setFieldValue('optionDeductible', String(indexCoverageCalcList))
        } else {
          indexCoverageCalcList = null;
        }

        const deductibles = coverageCalcList.map((cov, index) => {
          const coverage = cov.coverageCalc ? cov.coverageCalc[0] : '';
          return {
            value: String(index),
            label: coverage.deductibleDescription
          }
        }).filter((item, index, self) => index === self.findIndex(
          arr => arr.label === item.label && arr.label === item.label
        ));

        setGroupDeductible(deductibles);
      }

      handleGetQuote(quoteRequestDocument.documentCoverageList, null, indexCoverageCalcList);
    }
  }, [useGetDocumentsStatus, useGetOperationStatus])

  useEffect(() => {
    if (!useGetDocumentsExpiredStatus) return;
    if (useGetDocumentsExpiredStatus === 200) {
      const quoteDocumentsExpired = useGetDocumentsExpiredData.value?.find(document => document.idDomainStatus === 19);
      if (quoteDocumentsExpired) handleGetQuote(quoteDocumentsExpired.documentCoverageList, true);
    }
  }, [useGetDocumentsExpiredStatus])

  useEffect(() => {
    useGetOperationRequest(null, { loadLastDocument: true });
    useGetDocumentsRequest(null, { idDomain: 261 });
    useGetDocumentsExpiredRequest(null, { idDomain: 261, expiredDocumentsOnly: true });
    useVerifyRiskAcceptanceRequest(null, { draft: true });
    useGetQuestionnairesAnswersRequest();
    getQuoteQuestionnaire();
    formikRef.current.setFieldValue('optionDeductible', String(0))
  }, [])

  useEffect(() => {
    if (useComissionRateStatus === 200) {
      const { commissionValue, minCommissionValue } = useComissionRateData;

      setMinCommissionValue(minCommissionValue * 100);
      setMaxCommissionValue(commissionValue * 100);
    }
  }, [useComissionRateStatus]);

  useEffect(() => {
    if (useRecalculateSyncStatus === 200) {
      handleGetQuote(useRecalculateSyncData?.value)
    }
  }, [useRecalculateSyncStatus]);

  useEffect(() => {
    if (idProductPlan) {
      useComissionRateRequest(null, {
        idProduct: props.match?.params?.idProduct,
        idProductPlanSelected: idProductPlan
      });
    }
  }, [idProductPlan])

  useEffect(() => {
    if (useVerifyRiskAcceptanceStatus === 200 && useGetQuestionnairesAnswersStatus === 200) {
      const { riskDescription } = useVerifyRiskAcceptanceData?.value;

      let questionnaire = [];
      questionnaire = [
        ...useGetQuestionnairesAnswersData?.value.persons,
        ...useGetQuestionnairesAnswersData?.value.operations,
        ...useGetQuestionnairesAnswersData?.value.payments,
        ...useGetQuestionnairesAnswersData?.value.risks
      ];

      const forceAnalysis = questionnaire.find(question => question.idQuestion === 1201)?.idAnswerOption === 6129;

      setQuestionnaire(questionnaire.map(qst => {
        if ([1202, 1203, 1467].includes(qst.idQuestion)) {
          if (!qst.answer) qst.visibleQuestion = false;
          qst.behaviorObject.paddingRight = 0;
        } else if (qst.idQuestion === 1208) {
          qst.visibleQuestion = false;
        }
        return qst;
      }));
      setIsInAnalysis(riskDescription === 'Analisar' || forceAnalysis);
    }
  }, [useVerifyRiskAcceptanceStatus, useGetQuestionnairesAnswersStatus]);


  const handlePermissionEdit = () => {
    return !(
      isBound || !isInAnalysis ||
      operation?.document?.idDomainStatus === 20 ||
      (!permissions.NBI_REQUEST_APPROVE_REJECT && operation?.document?.idDomainStatus === 19)
    )
  }

  useEffect(() => {
    function resize() {
      if (window.innerWidth < 576) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
    resize();
    window.addEventListener('resize', resize);
    return () => {
      window.removeEventListener('resize', resize);
    }
  }, []);

  return (
    <Layout
      title={"Analise da Cotação"}
      subtitle={`${operation?.productName || ""}`}
    >
      <Row>
        <Col>
          <StepNavigation
            stage={2}
            idOperation={props.match?.params?.idOperation}
            idProduct={props.match?.params?.idProduct}
            permissions={permissions}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <BrokingSummary
            history={history}
            idOperation={props.match?.params?.idOperation}
            idProduct={props.match?.params?.idProduct} />
        </Col>
      </Row>

      <Content>
        <Formik
          validateOnChange={false}
          innerRef={formikRef}
          initialValues={{ calculationList: [], comission: 0, defaultValueCoverageDisabled: 'N/A' }}
          validationSchema={validationSchema.current}
          enableReinitialize={true}
          onSubmit={() => true}
        >
          {({ values, setFieldValue }) => {
            return (
              <Form onKeyDown={(e) => {
                if (e.key === 'Enter') e.preventDefault();
              }}>

                <CoverageContainer>
                  <NotesModal
                    title={'Informações Adicionais'}
                    textButtonConfirm={'Confirmar'}
                    textButtonCancel={'Cancelar'}
                    show={notesModal}
                    setModalShow={setNotesModal}
                    idOperation={props.match?.params?.idOperation}
                    idQuestion={1198}
                    functionCallback={async () => {
                      await useResetOperationStateRequest({ idDomainOrigin: 26 });
                      const { status } = await useUpdateOperationRequest({ idDomainStatus: 4 });
                      if (status === 200) history.push('/enquiries');
                    }}
                  />

                  {selectedOption != null && <DialogCalculation
                    show={true}
                    formikValues={values}
                    formikRef={formikRef}
                    setFieldValue={setFieldValue}
                    calcList={previousCoverageCalcList?.filter(calculations => calculations.coverageLimit)}
                    permissions={permissions}
                    selectedOption={selectedOption}
                    closeModal={() => {
                      setSelectedOption(null)
                    }}
                  />}

                  {isMobile
                    ? <MobileTable
                      formikValues={values}
                      formikRef={formikRef}
                      calcList={coverageCalcList.filter(calculations => calculations.coverageLimit)}
                      setFieldValue={setFieldValue}
                      history={history}
                      showAlterButton={isBound}
                      disabled={isBound || !isInAnalysis || operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16 || (!permissions.NBI_REQUEST_APPROVE_REJECT && operation?.document?.idDomainStatus === 19)}
                      newDisabled={isBound || !isInAnalysis || operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16 || (!permissions.NBI_REQUEST_APPROVE_REJECT && operation?.document?.idDomainStatus === 19)}
                      disabledCommision={
                        isBound || (isInAnalysis && !permissions.NBI_REQUEST_APPROVE_REJECT) || (isInAnalysis && (operation?.document?.idDomainStatus === 20 ||
                          operation?.document?.idDomainStatus === 16))
                      }
                      permissions={permissions}
                      idOperation={props.match?.params?.idOperation}
                      idProduct={props.match?.params?.idProduct}
                      susepProcess={operation?.susepProcess || '-'}
                      disabledConfirm={isBound || (operation?.document?.idDomainStatus !== 20 && operation?.document?.idDomainStatus !== 16)}
                      onConfirmPlanText={'CONTRATAR'}
                      showHistory={previousCoverageCalcList?.length}
                      showCoveragesAndExtensions={permissions.NBI_REQUEST_APPROVE_REJECT}
                      onConfirmPlan={async (index) => {
                        try {
                          if (operation?.document?.documentMetadata?.documentExpireDate && new Date(operation?.document?.documentMetadata?.documentExpireDate) < new Date()) {
                            return mc.error(`Cotação vencida. Por favor, gere novamente a cotação.`);
                          }

                          await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, coverageOption: index, idProductPlanSelected: idProductPlan } });
                          await useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: false });
                          await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });
                          await useGenerateQuoteRequest({ idDomainStatus: 20, idProductPlanSelected: idProductPlan })

                          history.push({ pathname: `/payment-configuration/${props.match?.params?.idOperation}`, state: { option: index, idProductPlanSelected: idProductPlan } });
                        } catch (e) {
                          loading.stop();
                          return mc.error('Falha ao confirmar a sua cotação, tente novamente!')
                        }
                      }}
                      onRecalculate={(value, index, fieldName) => {
                        const hasParameter = recalculateParameters.current.find(
                          (option) => option.coverageCalcIndex === index && option.idProductPlan === idProductPlan
                        );

                        if (hasParameter) {
                          hasParameter[fieldName] = value;
                        } else {
                          recalculateParameters.current.push({
                            coverageCalcIndex: index, [fieldName]: value, idProductPlan
                          })
                        }
                        useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
                      }}
                      handleCheckCoverage={(value, index, idCoverage) => {
                        const hasParameter = recalculateParameters.current.find((option) => option.coverageCalcIndex === index);

                        if (hasParameter) {
                          if (hasParameter.coveragesDisabled) {
                            hasParameter.coveragesDisabled = hasParameter.coveragesDisabled.filter((idCov) => idCov.idCoverage != idCoverage);
                            hasParameter.coveragesDisabled.push({ idCoverage, value });
                          } else if (value) {
                            hasParameter.coveragesDisabled = [{ idCoverage, value }];
                          }
                        } else {
                          recalculateParameters.current.push({ coverageCalcIndex: index, coveragesDisabled: [{ idCoverage, value }] })
                        }

                        useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
                      }}
                      onRecalculateItem={(value, index, idCoverage, fieldName, resetFieldName = 'dummyField') => {
                        const hasParameter = recalculateParameters.current.find((option) => option.coverageCalcIndex === index);
                        if (hasParameter) {
                          if (hasParameter.coverageItens) {
                            const hasCoverage = hasParameter.coverageItens.find((coverage) => coverage.idCoverage === idCoverage);
                            if (hasCoverage) {
                              hasCoverage[fieldName] = value;
                              hasCoverage[resetFieldName] = null;
                            } else {
                              hasParameter.coverageItens.push({ idCoverage, [fieldName]: value, [resetFieldName]: null })
                            }
                          } else {
                            hasParameter.coverageItens = [{ idCoverage, [fieldName]: value, [resetFieldName]: null }];
                          }
                        } else {
                          recalculateParameters.current.push({ coverageCalcIndex: index, coverageItens: [{ idCoverage, [fieldName]: value, [resetFieldName]: null }] })
                        }
                        useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
                      }}
                      openHistoryModel={(index) => {
                        setSelectedOption(index)
                      }}
                      onSelectDeductible={(value) => handleSelectDeductible(value)}
                      onOptionsDeductible={groupDeductible}
                      hasCoverageCalc={hasCoverageCalc}
                      minComission={minCommissionValue}
                      maxComission={maxComissionValue}
                    />

                    : <Table
                      componentTypeRender={'singleProductPlan'}
                      formikValues={values}
                      formikRef={formikRef}
                      calcList={coverageCalcList.filter(calculations => calculations.coverageLimit)}
                      setFieldValue={setFieldValue}
                      history={history}
                      showAlterButton={isBound}
                      disabled={isBound || !isInAnalysis || operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16 || (!permissions.NBI_REQUEST_APPROVE_REJECT && operation?.document?.idDomainStatus === 19)}
                      newDisabled={isBound || !isInAnalysis || operation?.document?.idDomainStatus === 20 || operation?.document?.idDomainStatus === 16 || (!permissions.NBI_REQUEST_APPROVE_REJECT && operation?.document?.idDomainStatus === 19)}
                      disabledCommision={
                        isBound || (!permissions.NBI_REQUEST_APPROVE_REJECT && isInAnalysis)
                      }
                      permissions={permissions}
                      idOperation={props.match?.params?.idOperation}
                      idProduct={props.match?.params?.idProduct}
                      susepProcess={operation?.susepProcess || '-'}
                      disabledConfirm={isBound || (operation?.document?.idDomainStatus !== 20 && operation?.document?.idDomainStatus !== 16)}
                      onConfirmPlanText={'CONTRATAR'}
                      showHistory={previousCoverageCalcList?.length}
                      showCoveragesAndExtensions={permissions.NBI_REQUEST_APPROVE_REJECT}
                      onConfirmPlan={async (index) => {
                        try {
                          if (operation?.document?.documentMetadata?.documentExpireDate && new Date(operation?.document?.documentMetadata?.documentExpireDate) < new Date()) {
                            return mc.error(`Cotação vencida. Por favor, gere novamente a cotação.`);
                          }

                          await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, coverageOption: index, idProductPlanSelected: idProductPlan } });
                          await useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: false });
                          await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });
                          await useGenerateQuoteRequest({ idDomainStatus: 20, idProductPlanSelected: idProductPlan })

                          history.push({ pathname: `/payment-configuration/${props.match?.params?.idOperation}`, state: { option: index, idProductPlanSelected: idProductPlan } });
                        } catch (e) {
                          loading.stop();
                          return mc.error('Falha ao confirmar a sua cotação, tente novamente!')
                        }
                      }}
                      onRecalculate={(value, index, fieldName) => {
                        const hasParameter = recalculateParameters.current.find(
                          (option) => option.coverageCalcIndex === index && option.idProductPlan === idProductPlan
                        );

                        if (hasParameter) {
                          hasParameter[fieldName] = value;
                        } else {
                          recalculateParameters.current.push({
                            coverageCalcIndex: index,
                            [fieldName]: value,
                            idProductPlan
                          })
                        }
                        useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
                      }}
                      handleCheckCoverage={(value, index, idCoverage) => {
                        const hasParameter = recalculateParameters.current.find((option) => option.coverageCalcIndex === index);

                        if (hasParameter) {
                          if (hasParameter.coveragesDisabled) {
                            hasParameter.coveragesDisabled = hasParameter.coveragesDisabled.filter((idCov) => idCov.idCoverage != idCoverage);
                            hasParameter.coveragesDisabled.push({ idCoverage, value });
                          } else if (value != null) {
                            hasParameter.coveragesDisabled = [{ idCoverage, value }];
                          }
                        } else {
                          recalculateParameters.current.push({ coverageCalcIndex: index, coveragesDisabled: [{ idCoverage, value }] })
                        }

                        useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
                      }}
                      onRecalculateItem={(value, index, idCoverage, fieldName, resetFieldName = 'dummyField') => {
                        const hasParameter = recalculateParameters.current.find((option) => option.coverageCalcIndex === index);
                        if (hasParameter) {
                          if (hasParameter.coverageItens) {
                            const hasCoverage = hasParameter.coverageItens.find((coverage) => coverage.idCoverage === idCoverage);
                            if (hasCoverage) {
                              hasCoverage[fieldName] = value;
                              hasCoverage[resetFieldName] = null;
                            } else {
                              hasParameter.coverageItens.push({ idCoverage, [fieldName]: value, [resetFieldName]: null })
                            }
                          } else {
                            hasParameter.coverageItens = [{ idCoverage, [fieldName]: value, [resetFieldName]: null }];
                          }
                        } else {
                          recalculateParameters.current.push({ coverageCalcIndex: index, coverageItens: [{ idCoverage, [fieldName]: value, [resetFieldName]: null }] })
                        }
                        useRecalculateSyncRequest({ recalculateParameters: recalculateParameters.current, idProductPlanSelected: idProductPlan }, { draft: true });
                      }}
                      openHistoryModel={(index) => {
                        setSelectedOption(index)
                      }}
                      onSelectDeductible={(value) => handleSelectDeductible(value)}
                      onOptionsDeductible={groupDeductible}
                      hasCoverageCalc={hasCoverageCalc}
                      minComission={minCommissionValue}
                      maxComission={maxComissionValue}
                      isInAnalysis={isInAnalysis}
                    />}
                </CoverageContainer>

                <div style={{
                  marginTop: 25
                }}>
                  {coverageCalcList.map((calc, index) => {
                    if (calc?.idProductPlan && !index) {
                      return (
                        <Clauses
                          idOperation={calc.idOperation}
                          idProduct={calc.idProduct || operation?.idProduct}
                          idProductPlan={calc.idProductPlan}
                          isInAnalysis={isInAnalysis}
                          permission={handlePermissionEdit()}
                          isLoading={(isLoading) => setClausesLoading(isLoading)}
                          onSelectClauses={(onSelectClauses) => {
                            setSelectedClauses(onSelectClauses)
                          }}
                        />
                      )
                    }
                    return <></>;
                  })}
                </div>

                <HasPermission permission={isInAnalysis}>
                  <div style={{ padding: '0 10px' }}>
                    <FormSection
                      sectionName="QUOTE_LETTER"
                      disableAll={true}
                      questionnaire={questionnaire}
                      values={values}
                      setFieldValue={setFieldValue}
                      ignoreTypeOfApplication
                      permissions={permissions}
                    />
                  </div>
                </HasPermission>

                <Row>
                  <Col>
                  </Col>
                </Row>

                <ButtonContainer style={{ padding: '0 10px' }}>
                  <Button forth style={{ width: 'auto' }} onClick={() => handleBack()}> &lt; VOLTAR </Button>
                  <ButtonContent>
                    <HasPermission permission={!isBound}>
                      {(operation?.idOperation && permissions.NBI_REQUEST_APPROVE_REJECT) && <LostCancelButton idQuestion={697} idOperation={props.match?.params?.idOperation} title={'PERDIDO'} />}

                      <HasPermission
                        permission={
                          isInAnalysis &&
                          operation?.idOperation &&
                          [10, 8].includes(operation?.idDomainStatus) &&
                          permissions.NBI_REQUEST_APPROVE_REJECT
                        }
                      >
                        <Button
                          type="button"
                          onClick={() => setNotesModal(true)}
                          third
                        >
                          MAIS INFO
                        </Button>
                      </HasPermission>

                      <HasPermission
                        permission={
                          isInAnalysis &&
                          operation?.idOperation &&
                          [10, 8].includes(operation?.idDomainStatus) &&
                          permissions.NBI_REQUEST_APPROVE_REJECT
                        }
                      >
                        <Button
                          id="btnContinue"
                          type="submit"
                          onClick={() => {
                            validationSchema.current.validate(values)
                              .then(async () => {
                                try {
                                  await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, idProductPlanSelected: idProductPlan } });
                                  if (fullCoverageList?.coverageCalcList?.length && fullCoverageList?.coverageCalcList[0]?.coverageCalc) {
                                    for (const coverageCalc of fullCoverageList.coverageCalcList) {
                                      await useRecalculateSyncRequest(
                                        {
                                          recalculateParameters: recalculateParameters.current,
                                          idProductPlanSelected: coverageCalc.idProductPlan
                                        },
                                        { draft: false }
                                      );
                                    }
                                  } else {
                                    await useRecalculateSyncRequest(
                                      {
                                        recalculateParameters: recalculateParameters.current,
                                        idProductPlanSelected: idProductPlan
                                      },
                                      { draft: false }
                                    );
                                  }
                                  await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });
                                } catch (e) {
                                  loading.stop();
                                  return mc.error('Falha ao confirmar a sua cotação, tente novamente!')
                                }
                              })
                              .catch((e) => {
                                console.log('validation error', e)
                              })
                          }}
                          style={{ marginLeft: 15 }}
                          secundary={true}
                        >
                          SALVAR
                        </Button>
                      </HasPermission>
                      <HasPermission permission={!isInAnalysis}>
                        <Button
                          id="btnContinue"
                          type="submit"
                          onClick={() => {
                            validationSchema.current.validate(values)
                              .then(async (index) => {
                                try {
                                  await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, idProductPlanSelected: idProductPlan } });
                                  if (fullCoverageList?.coverageCalcList?.length && fullCoverageList?.coverageCalcList[0]?.coverageCalc) {
                                    for (const coverageCalc of fullCoverageList.coverageCalcList) {
                                      await useRecalculateSyncRequest(
                                        {
                                          recalculateParameters: recalculateParameters.current,
                                          idProductPlanSelected: coverageCalc.idProductPlan
                                        },
                                        { draft: false }
                                      );
                                    }
                                  } else {
                                    await useRecalculateSyncRequest(
                                      {
                                        recalculateParameters: recalculateParameters.current,
                                        idProductPlanSelected: idProductPlan
                                      },
                                      { draft: false }
                                    );
                                  }
                                  await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });
                                  await useGenerateQuoteRequest({ idDomainStatus: isInAnalysis ? 16 : undefined, idProductPlanSelected: idProductPlan })

                                  return history.push(`/quote/document/${props?.match?.params?.idOperation}`);
                                } catch (e) {
                                  loading.stop();
                                  return mc.error('Falha ao confirmar a sua cotação, tente novamente!')
                                }
                              })
                              .catch((e) => {
                                console.log('validation error', e)
                              })
                          }}
                          style={{ marginLeft: 15 }}
                          primary
                        >
                          GERAR COTAÇÃO
                        </Button>
                      </HasPermission>
                      <HasPermission permission={isInAnalysis && permissions.NBI_REQUEST_APPROVE_REJECT}>
                        <Button
                          id="btnContinue"
                          type="submit"
                          onClick={() => {
                            validationSchema.current.validate(values)
                              .then(async () => {
                                await useUpdateOperationRequest({ operationMetadata: { ...operation?.operationMetadata, idProductPlanSelected: idProductPlan } });
                                if (fullCoverageList?.coverageCalcList?.length && fullCoverageList?.coverageCalcList[0]?.coverageCalc) {
                                  for (const coverageCalc of fullCoverageList.coverageCalcList) {
                                    await useRecalculateSyncRequest(
                                      {
                                        recalculateParameters: recalculateParameters.current,
                                        idProductPlanSelected: coverageCalc.idProductPlan
                                      },
                                      { draft: false }
                                    );
                                  }
                                } else {
                                  await useRecalculateSyncRequest(
                                    {
                                      recalculateParameters: recalculateParameters.current,
                                      idProductPlanSelected: idProductPlan
                                    },
                                    { draft: false }
                                  );
                                }
                                await useUpdateDocumentsClausesRequest({ selectedClauses }, { idDomainDocument: 261 });

                                history.push({ pathname: `/quote-letter/${props.match?.params?.idOperation}` })
                              })
                              .catch((e) => {
                                console.log('validation error', e)
                              })
                          }}
                          style={{ marginLeft: 15 }}
                          primary
                        >
                          CONTINUAR
                        </Button>
                      </HasPermission>
                    </HasPermission>
                  </ButtonContent>
                </ButtonContainer>
              </Form>
            )
          }}
        </Formik>
      </Content>
    </Layout >
  )
}
